(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noire-catalogue"] && !Shopify.designMode) return;
  try {
    
const noireRoots = new WeakMap();
function initNoire(root){
 if(noireRoots.has(root))return;
 const controller=new AbortController(),signal=controller.signal,cleanups=[];
 const listen=(target,type,handler,options={})=>target.addEventListener(type,handler,{...options,signal});
 noireRoots.set(root,()=>{controller.abort();cleanups.forEach(cleanup=>cleanup());noireRoots.delete(root);});
 root.querySelectorAll('[data-carousel]').forEach(carousel=>{
 const slides=[...carousel.querySelectorAll('.nr-slide')];
 const media=carousel.querySelector('.nr-product-media');
 slides.forEach(slide=>slide.querySelectorAll('img').forEach(image=>{image.draggable=false;image.loading='eager';}));
 if(slides.length<2)return;
 const controls=carousel.querySelector('.nr-carousel-controls'),position=carousel.querySelector('.nr-carousel-position'),pause=carousel.querySelector('[data-carousel-pause]'),dots=[...carousel.querySelectorAll('[data-carousel-dot]')];
 controls.hidden=false;
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 let current=0,paused=reduced.matches,hover=false,focused=false,visible=false,timer,start=null,suppress=false,request=0,disposed=false;
 const roman=n=>{let out='';[[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']].forEach(([v,t])=>{while(n>=v){out+=t;n-=v;}});return out;};
 const paint=()=>{pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?pause.dataset.play:pause.dataset.pause);pause.textContent=paused?'▷':'Ⅱ';};
 const resetDrag=()=>{
 carousel.classList.remove('is-dragging');
 slides.forEach(slide=>{slide.style.removeProperty('transform');slide.style.removeProperty('opacity');slide.style.removeProperty('visibility');slide.style.removeProperty('z-index');});
 };
 const render=n=>{
 current=n;
 slides.forEach((slide,i)=>{slide.classList.toggle('is-current',i===current);slide.setAttribute('aria-hidden',String(i!==current));});
 dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===current)));
 position.textContent=roman(current+1)+' / '+roman(slides.length);
 };
 const show=async n=>{
 const next=(n+slides.length)%slides.length,token=++request,image=slides[next].querySelector('img');
 if(image){image.loading='eager';if(typeof image.decode==='function'){try{await image.decode();}catch{}}}
 if(disposed||token!==request)return;
 resetDrag();render(next);
 };
 const schedule=()=>{
 clearTimeout(timer);
 if(disposed||!carousel.isConnected)return;
 if(!paused&&!hover&&!focused&&visible&&!start&&!document.hidden)timer=setTimeout(async()=>{
 if(!document.querySelector('dialog[open]'))await show(current+1);
 schedule();
 },4000);
 };
 const manual=n=>{show(n).then(schedule);};
 dots.forEach((dot,i)=>listen(dot,'click',()=>manual(i)));
 listen(pause,'click',()=>{paused=!paused;paint();schedule();});
 listen(carousel,'pointerenter',event=>{if(event.pointerType==='mouse'){hover=true;schedule();}});
 listen(carousel,'pointerleave',()=>{hover=false;schedule();});
 listen(carousel,'focusin',()=>{focused=true;schedule();});
 listen(carousel,'focusout',event=>{focused=carousel.contains(event.relatedTarget);schedule();});
 listen(media,'keydown',event=>{
 if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();manual(current+(event.key==='ArrowLeft'?-1:1));}
 });
 listen(media,'pointerdown',event=>{
 if(event.pointerType==='touch'||!event.isPrimary||(event.pointerType==='mouse'&&event.button!==0))return;
 ++request;resetDrag();suppress=false;
 start={id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,axis:null};
 schedule();
 });
 listen(media,'pointermove',event=>{
 if(!start||start.touch||start.id!==event.pointerId)return;
 const dx=event.clientX-start.x,dy=event.clientY-start.y;
 if(!start.axis&&Math.max(Math.abs(dx),Math.abs(dy))>8){
 start.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
 if(start.axis==='x'){media.setPointerCapture(event.pointerId);carousel.classList.add('is-dragging');suppress=true;}
 }
 if(start.axis!=='x')return;
 event.preventDefault();
 const width=media.getBoundingClientRect().width;
 start.dx=Math.max(-width,Math.min(width,dx));
 const neighbor=(current+(dx<0?1:-1)+slides.length)%slides.length;
 slides.forEach((slide,i)=>{
 const active=i===current||i===neighbor;
 slide.style.visibility=active?'visible':'hidden';slide.style.opacity=active?'1':'0';
 slide.style.zIndex=i===current?'1':'0';
 slide.style.transform='translateX('+(i===current?start.dx:start.dx+(dx<0?width:-width))+'px)';
 });
 },{passive:false});
 const finish=(event,cancelled=false)=>{
 if(!start||start.id!==event.pointerId)return;
 const gesture=start;start=null;
 if(media.hasPointerCapture(event.pointerId))media.releasePointerCapture(event.pointerId);
 const threshold=Math.min(60,Math.max(30,media.getBoundingClientRect().width*.15));
 if(!cancelled&&gesture.axis==='x'&&Math.abs(gesture.dx)>=threshold)manual(current+(gesture.dx<0?1:-1));
 else{resetDrag();schedule();}
 };
 listen(media,'pointerup',event=>finish(event));
 listen(media,'pointercancel',event=>finish(event,true));
 listen(media,'lostpointercapture',event=>finish(event,true));
 listen(media,'pointerleave',event=>{if(start&&!start.touch&&start.axis!=='x')finish(event,true);});
 listen(media,'click',event=>{
 if(suppress){event.preventDefault();event.stopImmediatePropagation();suppress=false;}
 },{capture:true});
 listen(media,'dragstart',event=>event.preventDefault());

 listen(media,'touchstart',event=>{
 if(event.touches.length!==1){start=null;resetDrag();schedule();return;}
 const touch=event.touches[0];
 ++request;resetDrag();suppress=false;
 start={id:touch.identifier,x:touch.clientX,y:touch.clientY,dx:0,axis:null,touch:true};
 schedule();
 },{passive:true});
 listen(media,'touchmove',event=>{
 if(!start?.touch)return;
 if(event.touches.length!==1){start=null;resetDrag();schedule();return;}
 const touch=[...event.touches].find(touch=>touch.identifier===start.id);
 if(!touch)return;
 const dx=touch.clientX-start.x,dy=touch.clientY-start.y;
 if(!start.axis&&Math.max(Math.abs(dx),Math.abs(dy))>8){
 start.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
 if(start.axis==='x'){carousel.classList.add('is-dragging');suppress=true;}
 }
 if(start.axis!=='x')return;
 if(event.cancelable)event.preventDefault();
 const width=media.getBoundingClientRect().width;
 start.dx=Math.max(-width,Math.min(width,dx));
 const neighbor=(current+(dx<0?1:-1)+slides.length)%slides.length;
 slides.forEach((slide,i)=>{
 const active=i===current||i===neighbor;
 slide.style.visibility=active?'visible':'hidden';slide.style.opacity=active?'1':'0';
 slide.style.zIndex=i===current?'1':'0';
 slide.style.transform='translateX('+(i===current?start.dx:start.dx+(dx<0?width:-width))+'px)';
 });
 },{passive:false});
 const finishTouch=(event,cancelled=false)=>{
 if(!start?.touch)return;
 if(![...event.changedTouches].some(touch=>touch.identifier===start.id))return;
 const gesture=start;start=null;
 const threshold=Math.min(60,Math.max(30,media.getBoundingClientRect().width*.15));
 if(!cancelled&&gesture.axis==='x'&&Math.abs(gesture.dx)>=threshold)manual(current+(gesture.dx<0?1:-1));
 else{resetDrag();schedule();}
 };
 listen(media,'touchend',event=>finishTouch(event),{passive:true});
 listen(media,'touchcancel',event=>finishTouch(event,true),{passive:true});
 let wheelDistance=0,wheelLast=0,wheelLockedUntil=0;
 listen(media,'wheel',event=>{
 if(event.ctrlKey)return;
 const horizontal=Math.abs(event.deltaX)>Math.abs(event.deltaY)||event.shiftKey;
 if(!horizontal)return;
 const delta=event.deltaX||event.deltaY;
 if(!delta)return;
 event.preventDefault();
 const now=performance.now();
 if(now<wheelLockedUntil)return;
 if(now-wheelLast>180||Math.sign(delta)!==Math.sign(wheelDistance))wheelDistance=0;
 wheelLast=now;
 wheelDistance+=delta*(event.deltaMode===1?16:event.deltaMode===2?media.clientWidth:1);
 if(Math.abs(wheelDistance)>=35){
 manual(current+(wheelDistance>0?1:-1));
 wheelDistance=0;wheelLockedUntil=now+450;
 }
 },{passive:false});

 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});
 observer.observe(carousel);
 listen(document,'visibilitychange',schedule);
 listen(reduced,'change',()=>{if(reduced.matches){paused=true;paint();schedule();}});
 cleanups.push(()=>{disposed=true;++request;clearTimeout(timer);observer.disconnect();resetDrag();});
 paint();render(0);
 });
 root.querySelectorAll('[data-open]').forEach(button=>listen(button,'click',()=>{const dialog=document.getElementById(button.dataset.open);if(dialog){dialog.showModal();document.documentElement.classList.add('nr-dialog-open');}}));
 root.querySelectorAll('dialog').forEach(dialog=>{
 dialog.querySelectorAll('[data-close]').forEach(button=>listen(button,'click',()=>dialog.close()));
 listen(dialog,'click',event=>{if(event.target===dialog)dialog.close();});
 listen(dialog,'close',()=>document.documentElement.classList.remove('nr-dialog-open'));
 });
 const motion=root.querySelector('[data-motion]');
 if(motion)listen(motion,'click',()=>{const paused=root.classList.toggle('nr-paused');motion.setAttribute('aria-pressed',String(paused));motion.setAttribute('aria-label',paused?motion.dataset.play:motion.dataset.pause);motion.textContent=paused?'▷':'Ⅱ';});
}
document.querySelectorAll('[data-noire-store]').forEach(initNoire);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-noire-store]').forEach(initNoire));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-noire-store]').forEach(root=>noireRoots.get(root)?.()));

  } catch(e) { console.error(e); }
})();
})();
